import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef,
} from '@angular/material/dialog';
import {
	Component,
	Inject,
	OnInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import 'jspdf-autotable';
import { DatePipe, NgFor } from '@angular/common';
import { Router } from '@angular/router';
import { User } from '@lmc-app/shared/interface/user.interface';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatButton } from '@angular/material/button';

interface Comment_Type {
	value: string;
	viewValue: string;
}
interface Disposition {
	id: string;
	name: string;
}
@Component({
	selector: 'app-comment-form',
	templateUrl: './comment-form.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./comment-form.component.scss'],
	imports: [
		MatFormField,
		MatLabel,
		MatInput,
		ReactiveFormsModule,
		FormsModule,
		MatSelect,
		NgFor,
		MatOption,
		MatButton,
	],
})
export class CommentFormComponent implements OnInit {
	comment_types: Comment_Type[] = [
		{ value: 'Regular', viewValue: 'Regular' },
		{ value: 'Email Notes', viewValue: 'Email Notes' },
	];
	dispositions: Disposition[] = [
		{ id: 'RIGHT PARTY CONTACT', name: 'RIGHT PARTY CONTACT' },
		{ id: 'WRONG NUMBER', name: 'WRONG NUMBER' },
		{ id: 'THIRD PARTY CONTACT', name: 'THIRD PARTY CONTACT' },
		{ id: 'BANKO/CCS', name: 'BANKO/CCS' },
		{ id: 'LEFT MESSAGE WITH 3RD PARTY', name: 'LEFT MESSAGE WITH 3RD PARTY' },
		{ id: 'LEFT MESSAGE WITH RPC', name: 'LEFT MESSAGE WITH RPC' },
		{ id: 'Hung up/ refusal to pay', name: 'Hung up/ refusal to pay' },
		{ id: 'NO ANSWER', name: 'NO ANSWER' },
		{ id: 'NO SERVICE', name: 'NO SERVICE' },
		{ id: 'ARRANGMENT MADE', name: 'ARRANGMENT MADE' },
		{ id: 'SKIP', name: 'SKIP' },
	];
	commentInfo: any;
	currentUser: User;
	constructor(
		public dialogRef: MatDialogRef<CommentFormComponent>,
		public datepipe: DatePipe,
		private apiService: LegacyApiService,
		private dialog: MatDialog,
		private router: Router,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		this.commentInfo = this.data;
		console.log(this.commentInfo, 'CommentForm');
	}
	deleteComment() {
		if (this.commentInfo.nls_data == 1) alert('Cannot Delete an NLS Note');
		else if (confirm('Are you sure you want to delete this Note?')) {
			this.apiService
				.deleteComment(this.commentInfo.comment_id, this.commentInfo.acctrefno)
				.subscribe((res) => {
					this.dialogRef.close(this.commentInfo);
				});
		}
	}
	updateComment() {
		if (this.commentInfo.nls_data == 1) alert('Cannot Update an NLS Note');
		else {
			this.apiService.updateComment(this.commentInfo).subscribe((res) => {
				console.log(this.commentInfo);
				this.dialogRef.close(this.commentInfo);
			});
		}
	}
}
